const DOSAGE_MIN_LENGTH = 3;
const DOSAGE_MAX_LENGTH = 200;
const REGEX_FOR_MIN_3_CHARS = /(?:[1-9]x[1-9])|(?:.{4,})/u;

export const getDosageMinLength = (): number => {
   return DOSAGE_MIN_LENGTH;
};

export const getDosageMaxLength = (): number => {
   return DOSAGE_MAX_LENGTH;
};

export const getDosageRegExp = (): RegExp => {
   return REGEX_FOR_MIN_3_CHARS;
};
